import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Company, Contract, Regulation, User } from 'src/app/core/models';
import { BaseModal } from 'src/app/core/utils/BaseModal';
import { ModalService, RegulationService, CompanyService, StorageService, StorageKey } from 'src/app/core/services';
import { Gb } from 'src/app/core/services/growthbook.service';
import { ModulesBequest } from '../contract-create-or-update/contract-create-or-update.component';

@Component({
  selector: 'app-contract-view-model',
  templateUrl: './contract-view-model.component.html',
  styleUrls: ['./contract-view-model.component.sass']
})
export class ContractViewModelComponent extends BaseModal implements OnInit {
  @ViewChild('carousel', { static: true }) carousel;
  isValid: boolean;
  lastState: any;
  public contract: Contract;
  public isLoading = false;
  public moduleI18n = [];
  public typeUnfoldLimit = 'less';
  public typeUnfoldSpeed = 'less';
  public typeUnfoldTemplate = 'less';
  public typeUnfoldAdditional = 'less';
  public regulations: Array<Regulation>;
  public companies: Array<Company>;
  public gb: Gb;
  public user: User = new User();
  public ecsModules = {
    open: false
  };
  public bequestModules = {
    open: false
  };

  public modulesBequest = ModulesBequest;

  constructor(
    modalService: ModalService,
    private regulationService: RegulationService,
    private companyService: CompanyService,
    private storageService: StorageService,
  ) {
    super(modalService);
    this.gb = new Gb();
  }

  async ngOnInit() {
    this.isLoading = true;
    this.contract = this.initialState?.contract as Contract || new Contract();
    this.moduleI18n = this.initialState?.modules;
    const user = this.storageService.get(StorageKey.currentUser);
    if (user != null) {
      this.user = user;
    }
    this.getSelects();
    await this.gb.init();
  }

  async getSelects() {
    const params = { regionId: this.contract.regionId };
    this.regulationService.list(params).then(res => {
      this.regulations = res.result;
    });
    await this.companyService.getAll().then(res => {
      this.companies = res;
    });
  }

  async onAllSubmited(): Promise<any> {
  }

  getModuleI18n(item) {
    const moduleFilter = this.moduleI18n.filter(module => module.id === item);
    return moduleFilter[0].value;
  }

  unfoldMoreLimit() {
    this.typeUnfoldLimit = this.typeUnfoldLimit === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document.getElementById(`limit`).scrollIntoView({ behavior: 'smooth' }),
      355);
  }

  unfoldMoreSpeed() {
    this.typeUnfoldSpeed = this.typeUnfoldSpeed === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document.getElementById(`speed`).scrollIntoView({ behavior: 'smooth' }),
      355);
  }

  unfoldMoreTemplate() {
    this.typeUnfoldTemplate = this.typeUnfoldTemplate === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document.getElementById(`template`).scrollIntoView({ behavior: 'smooth' }),
      355);
  }

  unfoldMoreAdditional() {
    this.typeUnfoldAdditional = this.typeUnfoldAdditional === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document.getElementById(`additional`).scrollIntoView({ behavior: 'smooth' }),
      355);
  }

  getRegulationName(regulationId) {
    const regulationFilter = this.regulations?.filter(item => item.id === regulationId).shift();
    return `${regulationFilter.id} - ${regulationFilter.shortDescription}`;
  }

  getCompanyName(id) {
    const company = this.companies?.filter(c => c.id === id);
    return company?.[0]?.name || '-';
  }

  openOrCloseEcsModules() {
    this.ecsModules.open = !this.ecsModules.open;
  }

  openOrCloseBequestModules() {
    this.bequestModules.open = !this.bequestModules.open;
  }

  getModulesBequest(id: string) {
    return this.modulesBequest.find(a => a.id === id)?.name || '-';
  }
}
